export const itemDefaultSize = 20;

export const setHeaderWidthLoadDetails = (state, ind, width, type) => {
  let header = ''
  if (type === 'pick') {
      header = state.detailsPageHeadersPick[ind];
      header.width = width;
      return {
          ...state,
          ...{
            detailsPageHeadersPick: [...state.detailsPageHeadersPick.slice(0, ind), ...[header], ...state.detailsPageHeadersPick.slice(ind + 1)],
            stops: state.loadsAssignedStops,
          },
        };
  } else {
      header = state.detailsPageHeadersDrop[ind];
      header.width = width;
      return {
          ...state,
          ...{
            detailsPageHeadersDrop: [...state.detailsPageHeadersDrop.slice(0, ind), ...[header], ...state.detailsPageHeadersDrop.slice(ind + 1)],
            stops: state.loadsAssignedStops,
          },
        };
  }  
};

export const setLoadNotes = (state, data) => {
  const { note, loadType } = data;
  const loadDetails = state.loadDetails;
  if (loadType === 'pick') {
    loadDetails.loadPickStopCommentsCount = Number(loadDetails.loadPickStopCommentsCount) + 1;
  } else {
    loadDetails.loadDropStopCommentsCount = Number(loadDetails.loadDropStopCommentsCount) + 1;
  }

  updateLoadDetailsState(state, loadDetails, state.hasError = false, state.message = '');

  return {
    ...state,
    loadNotes: {
      ...state.loadNotes,
      data: [...state.loadNotes.data, note],
    },
    notesLoading: false,
  };
};

export const setStopNotes = (state, note) => {
  const loadDetails = state.loadDetails;

  updateLoadDetailsState(state, loadDetails, state.hasError = false, state.message = '');
  return {
    ...state,
    stopNotes: {
      ...state.stopNotes,
      data: [...state.stopNotes.data, note.data],
    },
    notesLoading: false,
  };
};

export const getOrderNotes = (state, response, hasError = false, message = '') => {
  const data = response.data || [];
  return {
    ...state,
    ...{
      orderNotes: data,
      notesLoading: false,
      hasError,
      message,
    },
  };
};

export const setOrderNote = (state, data) => {
  const { response } = data;
  return {
    ...state,
    orderNotes: {
      ...state.orderNotes,
      data: [...state?.orderNotes?.data, response?.data],
    },
    notesLoading: false,
  };
};

export const setEmptyAllNotes = (state) => {
  return {
    ...state,
    loadNotes: [],
    stopNotes: [],
    orderNotes: [],
    notesLoading: false,
  };
};

export const setCallCheckLoadStopsStatus = (state, loadData) => {
  const currentFirstOrderId = loadData.rowState.stopData?.stopOrders[0].orderId;
  const loadDetails = state.loadDetails;
  const pickStops = loadDetails.pickStop;
  const dropStops = loadDetails.dropStop;

  pickStops.forEach(stop => {
    stop.stopOrders.forEach(order => {
        if (order.orderId === currentFirstOrderId) {
          stop.stopOrders.forEach(order => {
            order.stopStatus = loadData.value;
          })
        }
      })
  })

  dropStops.forEach(stop => {
    stop.stopOrders.forEach(order => {
        if (order.orderId === currentFirstOrderId) {
          stop.stopOrders.forEach(order => {
            order.stopStatus = loadData.value;
          })
        }
      })
  })

  return updateLoadDetailsState(state, loadDetails, state.hasError = false, state.message = '')
};

export const getLoadDetails = (state, response, hasError = false, message = '') => {
  const data = response.data || [];
  return updateLoadDetailsState(state, data, hasError, message);
};

const updateLoadDetailsState = (state, load, hasError = false, message = '') => ({
  ...state,
  ...{
    loadDetailsLoading: false,
    loadDetails:{
      loading: load.loading,
      carrierEmail: load.carrierEmail,
      carrierName: load.carrierName,
      changeOrderPoNumbers: load.changeOrderPoNumbers,
      dot: load.dot,
      driverEmail: load.driverEmail,
      driverName: load.driverName,
      driverPhone: load.driverPhone,
      dropStop: load.dropStop,
      dropStopStatus: load.dropStopStatus,
      efsAmount: load.efsAmount,
      hasError,
      loadDropStopCommentsCount: load.loadDropStopCommentsCount,
      loadId: load.loadId,
      loadNumber: load.loadNumber,
      loadPickStopCommentsCount: load.loadPickStopCommentsCount,
      loadType: load.loadType,
      mc: load.mc,
      message,
      pickStop: load.pickStop,
      pickStopStatus: load.pickStopStatus,
      scaleTicket: load.scaleTicket,
      pickStopAndOrders: extractDetailsStopToList(state)(createDetailsStopsArray(state)(load.pickStop, state.detailsPageHeadersPick, load.loadId, 'pick'), state.detailsPageHeadersPick),
      dropStopAndOrders: extractDetailsStopToList(state)(createDetailsStopsArray(state)(load.dropStop, state.detailsPageHeadersDrop, load.loadId, 'drop'), state.detailsPageHeadersDrop),
    }
  },
});

const extractDetailsStopToList = state => (stops) => {
  let orders = [];
  stops.forEach((stopItem, index) => {
    orders.push(stopItem);
    stopItem.orders.forEach(order => {
      orders.push(order);
    });
  });

  return orders;
};

const createDetailsStopsArray = state => (stops, headers, loadId, stopType) => {
  const stopsList = [];
  stops.forEach(stop => stopsList.push(createDetailsStop(stop, headers, loadId, stopType)));
  return stopsList;
};

const createDetailsStop = (stopData, headers, loadId, stopType) => {
  const stopDetailsData = {
    row: [],
    orders: [],
    rowState: {
      type: 'stop',
      loadType: stopType === 'pick' ? 'pickLoad' : 'dropLoad',
      loadId: loadId,
      stopData,
      visible: true,
      height: itemDefaultSize,
    },
  };

  stopData.stopOrders.forEach((order, i) => stopDetailsData.orders.push(createStopOrder(order, headers, stopData, stopType, i, loadId)));

  const firstStopData = stopData.stopOrders[0];

  for (let hederIndex = 0; hederIndex < headers.length; hederIndex++) {
    const headerItem = headers[hederIndex];
    let value = null;
    let fieldType = 'text';
    let editable = false;
    let cellStyle = {};
    let tooltip = null;
    if (!headerItem.leftAction) {
      switch (headerItem.key) {
        case 'status':
          value = firstStopData.stopStatus;
          fieldType = 'select';
          editable = true;
          break;
        case 'notes':
          value = stopData.stopNoteCount;
          fieldType = 'text';
          break;
        case 'appointment':
          value = stopData.appointment;
          fieldType = 'dateTime';
          break;
        case 'pickIn':
          value = stopData.pickIn;
          fieldType = 'dateTime';
          editable = true;
          break;
        case 'dropIn':
          value = stopData.dropIn;
          fieldType = 'dateTime';
          editable = true;
          break;
        case 'pickOut':
          value = stopData.pickOut;
          fieldType = 'dateTime';
          editable = true;
          break;
        case 'dropOut':
          value = stopData.dropOut;
          fieldType = 'dateTime';
          editable = true;
          break;
        case 'puDate':
          value = '';
          fieldType = '';
          editable = false;
          break;
        case 'dueDate':
          value = '';
          fieldType = '';
          editable = false;
          break;
        case 'deliverDate':
          value = '';
          fieldType = '';
          editable = false;
          break;
        case 'customer':
          value = firstStopData.customerCode;
          fieldType = 'text';
          break;
        case 'locationName':
          value = stopData.locationName;
          fieldType = 'text';
          break;
        case 'poNumber':
          value = firstStopData.poNumber;
          fieldType = 'text';
          break;
        case 'soNumber':
          value = firstStopData.soNumber;
          fieldType = 'text';
          break;
        case 'palletCount':
          value = stopData.palletCount;
          fieldType = 'text';
          break;
        case 'space':
          value = stopData.space;
          fieldType = 'text';
          break;
        case 'cases':
          value = stopData.cases;
          fieldType = 'text';
          break;
        case 'weight':
          value = stopData.weight;
          fieldType = 'text';
          break;
        case 'sequence':
          value = firstStopData.sequence;
          fieldType = 'text';
          break;
        case 'temperatureName':
          value = firstStopData.temperatureName;
          fieldType = 'text';
          break;
        case 'temperatureDegre':
          value = firstStopData.temperatureDegre;
          fieldType = 'text';
          break;
        case 'action':
          value = 'noteIcon';
          fieldType = 'action';
          break;
        default:
          break;
      }
    } else {
      value = '';
      fieldType = 'text';
    }

    stopDetailsData.row.push({
      key: headerItem.key,
      value,
      fieldType,
      displayState: 1,
      editable,
      cellStyle,
      tooltip,
    });
  }

  return stopDetailsData;
};

const createStopOrder = (order, headers, stopData, stopType, i, loadId) => {
  const stopOrderData = {
    row: [],
    rowState: {
      type: 'order',
      orderData: order,
      orderId: order.orderId,
      loadId: loadId,
      visible: true,
      reacted: false,
      height: itemDefaultSize,
    },
  };

  for (let hederIndex = 0; hederIndex < headers.length; hederIndex++) {
    const headerItem = headers[hederIndex];
    let value = null;
    let value2 = null;
    let fieldType = 'text';
    let editable = false;
    let cellStyle = {};
    let tooltip = null;
    if (!headerItem.leftAction) {
      switch (headerItem.key) {
        case 'status':
          value = order.stopStatus;
          fieldType = 'select';
          editable = false;
          break;
        case 'notes':
          value = order.orderNoteCount;
          fieldType = 'text';
          break;
        case 'appointment':
          value = order.appointment;
          fieldType = 'dateTime';
          break;
        case 'pickIn':
          value = stopData.pickIn;
          fieldType = 'dateTime';
          break;
        case 'dropIn':
          value = stopData.dropIn;
          fieldType = 'dateTime';
          break;
        case 'pickOut':
          value = stopData.pickOut;
          fieldType = 'dateTime';
          break;
        case 'dropOut':
          value = stopData.dropOut;
          fieldType = 'dateTime';
          break;
        case 'puDate':
          value = order.puDate;
          fieldType = 'date';
          editable = stopType === 'pick' ? true : false;
          break;
        case 'dueDate':
          value = order.dueDate;
          fieldType = 'date';
          editable = false;
          break;
        case 'deliverDate':
          value = order.deliverDate;
          fieldType = 'date';
          editable = stopType === 'pick' ? true : false;
          break;
        case 'customer':
          value = order.customerCode;
          fieldType = 'text';
          break;
        case 'locationName':
          value = order.locationName;
          fieldType = 'text';
          break;
        case 'poNumber':
          value = order.poNumber;
          fieldType = 'text';
          break;
        case 'soNumber':
          value = order.soNumber;
          fieldType = 'text';
          break;
        case 'palletCount':
          value = order.palletCount;
          fieldType = 'text';
          break;
        case 'space':
          value = order.space;
          fieldType = 'text';
          break;
        case 'case':
          value = order.case;
          fieldType = 'text';
          break;
        case 'weight':
          value = order.weight;
          fieldType = 'text';
          break;
        case 'sequence':
          value = order.sequence;
          fieldType = 'text';
          break;
        case 'temperatureName':
          value = order.temperatureName;
          fieldType = 'text';
          break;
        case 'temperatureDegre':
          value = order.temperatureDegre;
          fieldType = 'text';
          break;
        case 'action':
          value = 'noteIcon';
          fieldType = 'action';
          break;
        default:
          break;
      }
    } else {
      value = '';
      fieldType = 'text';
    }

    stopOrderData.row.push({
      key: headerItem.key,
      value,
      value2,
      fieldType,
      displayState: 1,
      editable,
      cellStyle,
      tooltip,
    });
  }

  return stopOrderData;
};

export const setLoadDetails = (state, data, hasError = false, message = '') => {
  const { value, type } = data;
  
  return {
    ...state,
      loadDetailsLoading: false,
      loadDetails: {
        ...state.loadDetails,
        pickStopStatus: type === 'pick' ? value : state.loadDetails.pickStopStatus,
        dropStopStatus: type === 'drop' ? value : state.loadDetails.dropStopStatus,
      },
      hasError,
      message,
  };
};

export const setInLoadingNotes = state => ({
  ...state,
  ...{
    notesLoading: true,
  },
});

export const setInLoadingLoadDetails = state => ({
  ...state,
  ...{
    loadDetailsLoading: true,
  },
});

export const setCallCheckLoadsStopSDateDetails = (state, data) => {
  const { rowState, value, header } = data;
  const loadDetails = state.loadDetails;
  const orderIdForStop = rowState.stopData?.stopOrders?.[0].orderId || rowState.stopData?.stopOrders?.[0].subOrderId;
  const orderIdForOrder = rowState.orderData?.orderId || rowState.orderData?.subOrderId;

  if (rowState.type === 'stop') {
    // for checkIn checkOut
    if (rowState.loadType === 'pickLoad') {
      loadDetails.pickStop.forEach(stop => {

        if (stop.stopOrders?.[0].orderId === orderIdForStop) {
          if (header.key === 'pickIn') {
            stop.pickIn = value;
          }
          if (header.key === 'pickOut') {
            stop.pickOut = value;
          }
          if (header.key === 'puDate') {
            if (stop.stopOrders?.[0].orderId === orderIdForStop) {
              stop.stopOrders.forEach(order => {
                order.puDate = value
              })
            }
          }
        }
      });
    } else if (rowState.loadType === 'dropLoad') {
      loadDetails.dropStop.forEach(stop => {
        if (stop.stopOrders?.[0].orderId === orderIdForStop) {
          if (header.key === 'dropIn') {
            stop.dropIn = value;
          } 
          if (header.key === 'dropOut') {
            stop.dropOut = value;
          }
          if (header.key === 'puDate') {
            if (stop.stopOrders?.[0].orderId === orderIdForStop) {
              stop.stopOrders.forEach(order => {
                order.puDate = value
              })
            }
          }
        }
      });
    }
  } else if (rowState.type === 'order') {
    // type is order and header is puDate 
    loadDetails.pickStop.forEach(stop => {
        stop.stopOrders.forEach(order => {
          if (order.orderId === orderIdForOrder) {
            order.puDate = value
          }
        })
      });

      loadDetails.dropStop.forEach(stop => {
        stop.stopOrders.forEach(order => {
          if (order.orderId === orderIdForOrder) {
            order.puDate = value
          }
        })
      });
  }
  
  return updateLoadDetailsState(state, loadDetails, state.hasError = false, state.message = '');
};

export const setCallCheckLoadsOrderDeliverDateDetails = (state, data) => {
  const { rowState, value } = data;
  const loadDetails = state.loadDetails;
  const orderId = rowState.orderData.orderId || rowState.orderData.subOrderId;
  
  loadDetails.pickStop.forEach(stop => {
    stop.stopOrders.forEach(order => {
      if (order.orderId === orderId) {
        order.deliverDate = value
      }
    })
  });

  loadDetails.dropStop.forEach(stop => {
    stop.stopOrders.forEach(order => {
      if (order.orderId === orderId) {
        order.deliverDate = value
      }
    })
  });

  return updateLoadDetailsState(state, loadDetails, state.hasError = false, state.message = '');
};

// EFS reducers
export const setEFSLoading = state => ({
  ...state,
  ...{
    EFSLoading: true,
  },
});

export const getEmptyEFS = (state, response, hasError = false, message = '') => {
    const data = response.data || [];
    return {
        ...state, ...{
            EFS: data,
            EFSLoading: false,
            hasError: hasError || data.hasError,
            message: message || data.message,
        }    
    }
};

export const getEFS = (state, response, hasError = false, message = '') => {
    const data = response.data || [];
    return {
        ...state, ...{
            EFS: data,
            EFSLoading: false,
            hasError: hasError || data.hasError,
            message: message || data.message,
        }    
    }
};

export const getEFSList = (state, response, hasError = false, message = '') => {
    const data = response.data || [];
    return {
        ...state, ...{
            EFSList: data,
            EFSLoading: false,
            hasError: hasError || data.hasError,
            message: message || data.message,
        }    
    }
};

export const setEFS = (state, response, hasError = false, message = '') => {
    const data = response.data || [];
    return {
        ...state, ...{
            EFS: data,
            EFSLoading: false,
            hasError: hasError || data.hasError,
            message: message || data.message,
        }    
    }
};

export const updateEFS = (state, response, hasError = false, message = '') => {
    const data = response.data || [];
    return {
        ...state, ...{
            EFS: data,
            EFSLoading: false,
            hasError: hasError || data.hasError,
            message: message || data.message,
        }    
    }
};

export const reactOnItem = (state, type, orderId) => {
  const pickStops = state.loadDetails.pickStopAndOrders;
  const dropStops = state.loadDetails.dropStopAndOrders;

  if (type === 'pick') {
    pickStops.forEach(order => {
      if (order?.rowState?.orderId === orderId) {
        order.rowState.reacted = !order.rowState.reacted;
      }
    })
  } else {
    dropStops.forEach(order => {
      if (order?.rowState?.orderId === orderId) {
        order.rowState.reacted = !order.rowState.reacted;
      }
    })
  }

  return {
    ...state,
      loadDetails: {
        ...state.loadDetails,
        pickStopAndOrders: pickStops,
        dropStopAndOrders: dropStops,
      },
  };
};
